import React from "react"
import { Link } from "gatsby"
import OurHomeImg from "../../images/our-home.png"
import BgOurHome from "../../images/bg-our-home.png"

const OurHomes = () => {
  return (
    <div className="bg-primary">
      <div className="container mx-auto lg:py-16">
        <div className="flex flex-col md:flex-row lg:items-center lg:px-6">
          <div className="hidden lg:block lg:w-1/2">
            <img
              src={OurHomeImg}
              alt="Nuestro segundo hogar"
              className="mx-auto"
            />
          </div>
          <div className="w-full text-white">
            <div
              className="text-5xl font-normal leading-tight bg-no-repeat bg-center bg-cover lg:w-3/5 lg:bg-none text-shadow"
              style={{ backgroundImage: `url(${BgOurHome})` }}
            >
              <div className="bg-opacity-50 bg-primary pb-8 px-6 pt-80 lg:pt-0">
                <h3>
                  <span className="block font-bold">Our</span> offices
                </h3>
                <h4 className="block text-3xl font-medium pt-8">
                  A second home
                </h4>
              </div>
            </div>
            <p className="pt-8 px-6">
              We understand that workspace is now like our second home, which is
              why we promote a relaxed work environment, creating activities to
              relieve stress and supporting the emotional and physical health of
              our team.
            </p>
            <p className="pt-8 px-6 pb-8">
              We seek to make each member of Team AVALITH feel comfortable at
              work, fostering passion and commitment as a result.
            </p>
            <div className="px-6 pb-12">
              <Link
                to="/about-us/our-offices"
                alt="The offices"
                className="lg:mr-5 lg:mx-0 my-8 border-white border-solid border-2 hover:text-white hover:bg-secondary hover:text-variant btn"
              >
                Get to know them
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OurHomes
